import { Typography } from 'antd';
import React from 'react';
import {
  FormConfigProps,
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { DynamicFormField } from '../DynamicFormField';

export const implementationMethodsConfig: Record<string, FormConfigProps> = {
  independently: {
    label: 'savarankiškai',
    value: 'independently',
  },
  minimalAssistance: {
    label: 'su minimalia pagalba',
    value: 'minimalAssistance',
  },
  significantAssistance: {
    label: 'su žymia pagalba',
    value: 'significantAssistance',
  },
  alternativeAssessments: {
    label:
      'tradiciniai patikrinamieji darbai keičiami alternatyviais atsiskaitymo būdais',
    value: 'alternativeAssessments',
  },
  intermediateAssessments: {
    label: 'skiriami tarpiniai atsiskaitymai',
    value: 'intermediateAssessments',
  },
  reducedTasks: {
    label: 'mažinamas užduočių kiekis',
    value: 'reducedTasks',
    children: {
      reducedTasks75: {
        label: '75%',
        value: 'reducedTasks75',
        paddingLeft: 24,
      },
      reducedTasks50: {
        label: '50%',
        value: 'reducedTasks50',
        paddingLeft: 24,
      },
      reducedTasks25: {
        label: '25%',
        value: 'reducedTasks25',
        paddingLeft: 24,
      },
    },
  },
  separateTasksProvided: {
    label: 'pateikiamos atskirai parengtos užduotys',
    value: 'separateTasksProvided',
  },
  closedQuestions: {
    label: 'testai, kuriuose mokinys atsako į uždaro tipo klausimus',
    value: 'closedQuestions',
  },
  mixedQuestions: {
    label: 'testai, kuriuose mokinys atsako į atviro tipo klausimus',
    value: 'mixedQuestions',
  },
  openQuestionsSupport: {
    label:
      'atviro tipo klausimuose pateikiamos sakinių pradžios / atraminiai žodžiai',
    value: 'openQuestionsSupport',
  },
  other: {
    label: 'kita:',
    value: 'other',
    isInput: true,
  },
};

export const Block41 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 6 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Atlikimo būdai:
        </Typography.Title>
        <DynamicFormField
          formItemConfig={implementationMethodsConfig}
          formPathParams={['subject', 'block4', 'implementationMethods']}
          form={form}
        />
      </div>
    );
  },
);
